import api from './axios';

export async function get_all_contacts() {
    try {
        let res = await api.get('/contacts/');
        res = res.data;
        return res;
    } catch (err) {
        throw err;
    }
}

export async function get_contact_by_id(contact_id) {
    try {
        let res = await api.get(`/contacts/${contact_id}`);
        res = res.data;
        return res;
    }
    catch (err) {
        throw err;
    }
}

export async function add_contact(contact) {
    try {
        let res = await api.post('/contacts/add', contact);
        res = res.data;
        return res;
    }
    catch (err) {
        if (err.response) {
            throw {
                message: err.response.data.error,
                status: err.response.status
            };
        }
        throw { message: "Unknown error", status: 500 };
    }
}

export async function update_contact(contact) {
    try {
        const res = await api.put(`/contacts/update/${contact.id}`, contact);
        return res.data;
    } catch (err) {
        throw err;
    }
}


export async function delete_contact(contact_id) {
    try {
        const res = await api.delete(`/contacts/delete/${contact_id}`);
        return res.data;
    } catch (err) {
        throw err;
    }
}